import { Check } from 'lucide-react'

export type Step = { label: string; state: 'done' | 'current' | 'todo' }

/** Process steps in one segmented line: done ✓ · current (accent) · to do. */
export function StepRail({ steps, label = 'Steps' }: { steps: Step[]; label?: string }) {
  return (
    <ol aria-label={label} className="flex shrink-0">
      {steps.map((s, i) => (
        <li
          key={s.label}
          aria-current={s.state === 'current' ? 'step' : undefined}
          className={[
            'flex items-center gap-1 border px-3 py-[5px] text-[12.5px] leading-4',
            i === 0 ? 'rounded-l-md' : '-ml-px',
            i === steps.length - 1 ? 'rounded-r-md' : '',
            s.state === 'current'
              ? 'relative z-[1] border-primary bg-primary font-semibold text-accent-fg'
              : s.state === 'done'
                ? 'border-input text-ok'
                : 'border-input text-text-3',
          ].join(' ')}
        >
          {s.state === 'done' && <Check aria-hidden className="size-3.5" />}
          {s.label}
          {s.state === 'done' && <span className="sr-only"> (done)</span>}
        </li>
      ))}
    </ol>
  )
}
